import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import GridTable from '../../components/shared/grid-table';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div id="response-codes">
      <h2>{`Response Codes`}</h2>
      <p>{`The API will return a `}<a href="/docs/api/schema#meta-object">{`Meta Object`}</a>{` in its response containing one of the following codes to describe the result of your request.`}</p>
      <GridTable mdxType="GridTable">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": "left"
              }}>{`Code`}</th>
              <th parentName="tr" {...{
                "align": "left"
              }}>{`Type`}</th>
              <th parentName="tr" {...{
                "align": "left"
              }}>{`Description`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": "left"
              }}>{`200`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}>{`OK`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}>{`Your request was successful!`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": "left"
              }}>{`400`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}>{`Bad Request`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}>{`Your request was formatted incorrectly or missing a required parameter(s).`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": "left"
              }}>{`403`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}>{`Forbidden`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}>{`You weren't authorized to make your request; most likely this indicates an issue with your API Key.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": "left"
              }}>{`404`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}>{`Not Found`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}>{`The particular GIF or Sticker you are requesting was not found. This occurs, for example, if you request a GIF by using an id that does not exist.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": "left"
              }}>{`429`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}>{`Too Many Requests`}</td>
              <td parentName="tr" {...{
                "align": "left"
              }}>{`Your API Key is making too many requests. Read about requesting a Production Key to upgrade your API Key rate limits.`}</td>
            </tr>
          </tbody>
        </table>
      </GridTable>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      